module.exports = __webpack_public_path__ + "img/object_utilyg.3ba00be2.svg";